// Features that have bulk import/export on the Bulk Tools page. Import needs
// "create" and export needs "read" on the matching module.
export const BULK_TOOL_MODULES = [
    "product",
    "brand",
    "category",
    "coupon",
    "banner",
    "goalCategory",
    "customGoal",
    "featureVideo",
    "faq",
    "onboardingQA",
    "spendTrackerCategory",
];

// The Messaging page (backend/docs/MESSAGING.md): Services and Routing (messagingSettings),
// SMS and WhatsApp templates (messagingTemplates) and the message log (messagingLogs). The
// page shows with read on any of them; each tab needs read on its own module.
export const MESSAGING_MODULES = ["messagingSettings", "messagingTemplates", "messagingLogs"];

// The WhatsApp inbox and campaigns pages (backend/docs/WHATSAPP_INBOX.md). Each page shows
// with read on its own module; create sends (a reply, a test, a campaign) and update changes
// (read, done, assign; stop a campaign).
export const WHATSAPP_INBOX_MODULE = "whatsappInbox";
export const WHATSAPP_CAMPAIGNS_MODULE = "whatsappCampaigns";
